import Vue from "vue";
import Router from "vue-router";


// import retrieve from '@/components/retrieve'
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component:() => import("@/views/compe-table.vue")
    },
    {
      path: "/index",
      component:() => import("@/views/compe-table.vue")
    },
    {
      path: "/index.html",
      component:() => import("@/views/compe-table.vue")
    },
    {
      path: "/apply",
      component: () => import("@/views/apply.vue")
    },
    {
      path: "/anchor-detail",
      component: () => import("@/views/anchor-detail.vue")
    },
    {
      path: "/anchor-detail-iframe",
      component: () => import("@/views/anchor-detail-iframe.vue")
    },
    {
      path: "/anchor-live",
      component: () => import("@/views/anchor-live.vue")
    },
    {
      path: "/compe-detail",
      component: () => import("@/views/compe-detail.vue")
    },
    // {
    //   path: "/compe-table",
    //   component: () => import("@/views/compe-table.vue")
    // },
    // {
    //   path: "/schedule",
    //   component: () => import("@/views/matches-schedule.vue")
    // },
    // {
    //   path: "/live",
    //   component: () => import("@/views/live.vue")
    // },
    {
      path: "/download",
      component: () => import("@/views/download.vue")
    },
    {
      path: "/retrieve",
      component: () => import("@/views/retrieve.vue")
    }
    ,
    {
      path: "/agreement",
      component: () => import("@/views/agreement.vue")
    }
    ,
    {
      path: "/phone_index",
      component: () => import("@/views/phone_index.vue")
    }
    ,
    {
      path: "/phonelive-detail",
      component: () => import("@/views/phonelive-detail.vue")
    }
    ,
    {
      path: "/phoneanchar-detail",
      component: () => import("@/views/phoneanchar-detail.vue")
    }
    ,
    {
      path: "/collection",
      component: () => import("@/views/collection.vue")
    }
    ,
    {
      path: "/collection_detail",
      component: () => import("@/views/collection_detail.vue")
    }
    ,
    {
      path: "/infor",
      component: () => import("@/views/infor.vue")
    }
    ,
    {
      path: "/infor_detail",
      component: () => import("@/views/infor_detail.vue")
    }
    ,
    {
      path: "/alternate",
      component: () => import("@/views/alternate_domain_list.vue")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js